import { User, Guild } from '../context/auth-context';

const CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;
const API_URL = process.env.REACT_APP_DISCORD_API_URL || 'https://discord.com/api/v10';

export const discordService = {
  getOAuthUrl: () => {
    const params = new URLSearchParams({
      client_id: CLIENT_ID || '',
      redirect_uri: REDIRECT_URI || '',
      response_type: 'token',
      scope: 'identify email guilds applications.commands.permissions.update',
    });
    return `https://discord.com/oauth2/authorize?${params.toString()}`;
  },

  getUserProfile: async (accessToken: string): Promise<User> => {
    const response = await fetch(`${API_URL}/users/@me`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user profile');
    }

    const data = await response.json();
    return {
      id: data.id,
      username: data.username,
      discriminator: data.discriminator,
      avatar: data.avatar,
      email: data.email,
    };
  },

  getUserGuilds: async (accessToken: string): Promise<Guild[]> => {
    const response = await fetch(`${API_URL}/users/@me/guilds`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user guilds');
    }

    const guilds: Guild[] = await response.json();
    
    // Filter for MANAGE_GUILD permission (0x20)
    return guilds.filter(guild => {
        const permissions = BigInt(guild.permissions);
        return (permissions & BigInt(0x20)) === BigInt(0x20);
    });
  },
  
  getAvatarUrl: (userId: string, avatarHash: string | null) => {
      if (!avatarHash) {
          return `https://cdn.discordapp.com/embed/avatars/0.png`; 
      }
      return `https://cdn.discordapp.com/avatars/${userId}/${avatarHash}.png`;
  },

  getGuildIconUrl: (guildId: string, iconHash: string | null) => {
    if (!iconHash) {
        return `https://cdn.discordapp.com/embed/avatars/0.png`; // Placeholder
    }
    return `https://cdn.discordapp.com/icons/${guildId}/${iconHash}.png`;
  },

  getAddBotUrl: (guildId: string) => {
      const params = new URLSearchParams({
          client_id: CLIENT_ID || '',
          permissions: '8', // Administrator or whatever you need
          scope: 'bot applications.commands',
          guild_id: guildId,
          disable_guild_select: 'true'
      });
      return `https://discord.com/api/oauth2/authorize?${params.toString()}`;
  }
};